import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

function TodaysTrades({ trades, assetClasses, currency }) {
  const acMap = Object.fromEntries(assetClasses.map(a => [a.asset_class_id, a.name]));

  return (
    <Card data-testid="todays-trades-card" className="border border-border">
      <CardHeader>
        <CardTitle className="text-xl sm:text-2xl tracking-tight font-semibold">
          Today's Trades
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        {trades.length === 0 ? (
          <div className="h-[260px] flex items-center justify-center text-muted-foreground text-sm">
            No trades placed today
          </div>
        ) : (
          <div className="space-y-2 max-h-[260px] overflow-y-auto">
            {trades.map((t) => (
              <div
                key={t.transaction_id}
                data-testid={`today-trade-${t.transaction_id}`}
                className="flex items-center justify-between p-3 border border-border rounded-md"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <Badge
                    className={
                      t.type === 'Buy'
                        ? 'bg-success/10 text-success border-success/20'
                        : 'bg-destructive/10 text-destructive border-destructive/20'
                    }
                  >
                    {t.type}
                  </Badge>
                  <div className="min-w-0">
                    <p className="font-semibold text-sm truncate">{t.symbol}</p>
                    <p className="text-xs text-muted-foreground truncate">
                      {acMap[t.asset_class_id] || t.asset_class_id} · {format(new Date(t.date), 'MMM dd')}
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-sm font-semibold">
                    {t.quantity} × {currency} {t.price.toFixed(2)}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    Total: {currency} {t.total_amount.toFixed(2)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default TodaysTrades;
